<mobile-page-content [fullPageWidth]="true" class="page-content">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <app-mobile-test-side-menu [tests]="testsLeftMenu" [organization]="organization" [athleteUser]="athleteUser" [activeTestId]="activeTestId"></app-mobile-test-side-menu>

    <module-content *ngIf="!is401 && !is404">
        <app-test-generic-container [organization]="organization" [athleteUser]="athleteUser" [test]="test" (updateSideMenuEvent)="updateSideMenuEvent()"></app-test-generic-container>
    </module-content>
</mobile-page-content>
